if (!customElements.get('geolocation-modal')) {
    customElements.define('geolocation-modal', class GeolocationModal extends ModalDialog {
        constructor() {
            super();
            this.modalContent = this.querySelector('[id="GeolocationInfo"]');
            this.querySelector('[id="closeModalButton"]').addEventListener(
                'click',
                this.hide.bind(this, false)
            );
        }
  
        hide(preventFocus = false) {
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification) cartNotification.setActiveElement(this.openedBy);
           if(this.modalContent){ this.modalContent.innerHTML = ''};
            
            if (preventFocus) this.openedBy = null;
            super.hide();
        }
  
        show(opener) {
            opener.setAttribute('aria-disabled', true);
            opener.classList.add('loading');
        }
    });
}
